/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

const mockCountryRegions = [
    {
        CountryRegionId: 'ABW',
        ShortName: 'Aruba',
        LongName: 'Aruba',
        ISOCode: 'AW',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0001',
        AddressFormatName: 'Street;City_State_PostCode; Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'AFG',
        ShortName: 'Afghanistan',
        LongName: 'Islamic Republic of Afghanistan',
        ISOCode: 'AF',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 3,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0006',
        AddressFormatName: 'Street;City;State;County;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'AGO',
        ShortName: 'Angola',
        LongName: 'Republic of Angola',
        ISOCode: 'AO',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 3,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0006',
        AddressFormatName: 'Street;City;State;County;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'AIA',
        ShortName: 'Anguilla',
        LongName: 'Anguilla',
        ISOCode: 'AI',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 3,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0006',
        AddressFormatName: 'Street;City;State;County;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'ALA',
        ShortName: '\u00C5land Islands',
        LongName: '\u00C5land Islands',
        ISOCode: 'AX',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0001',
        AddressFormatName: 'Street;City_State_PostCode; Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'ALB',
        ShortName: 'Albania',
        LongName: 'Republic of Albania',
        ISOCode: 'AL',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 3,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0006',
        AddressFormatName: 'Street;City;State;County;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'AND',
        ShortName: 'Andorra',
        LongName: 'Principality of Andorra',
        ISOCode: 'AD',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 3,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0006',
        AddressFormatName: 'Street;City;State;County;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'ANT',
        ShortName: 'Netherlands Antilles',
        LongName: 'Netherlands Antilles',
        ISOCode: 'AN',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0001',
        AddressFormatName: 'Street;City_State_PostCode; Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'ARE',
        ShortName: 'United Arab Emirates',
        LongName: 'United Arab Emirates',
        ISOCode: 'AE',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 3,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0006',
        AddressFormatName: 'Street;City;State;County;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'ARG',
        ShortName: 'Argentina',
        LongName: 'Argentine Republic',
        ISOCode: 'AR',
        TimeZone: 0,
        LanguageId: 'EN-US',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 8,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 9,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 3,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 6,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 7,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 8,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0012',
        AddressFormatName: 'Street_Number_Complement;County;City,State,PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'ARM',
        ShortName: 'Armenia',
        LongName: 'Republic of Armenia',
        ISOCode: 'AM',
        TimeZone: 0,
        LanguageId: 'EN-US',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 3,
                LineNumber: 4,
                IsDataEntryOnly: true,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 6,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0008',
        AddressFormatName: 'Street;City,State_PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'ASM',
        ShortName: 'American Samoa',
        LongName: 'Territory of American Samoa',
        ISOCode: 'AS',
        TimeZone: 0,
        LanguageId: 'EN-US',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0001',
        AddressFormatName: 'Street;City_State_PostCode; Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'ATA',
        ShortName: 'Antarctica',
        LongName: 'Antarctica',
        ISOCode: 'AQ',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0001',
        AddressFormatName: 'Street;City_State_PostCode; Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'ATF',
        ShortName: 'French Southern and Antarctic Lands',
        LongName: 'Territory of the French Southern and Antarctic Lands',
        ISOCode: 'TF',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0003',
        AddressFormatName: 'Street;City,State_PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'ATG',
        ShortName: 'Antigua and Barbuda',
        LongName: 'Antigua and Barbuda',
        ISOCode: 'AG',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 3,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0006',
        AddressFormatName: 'Street;City;State;County;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'AUS',
        ShortName: 'Australia',
        LongName: 'Commonwealth of Australia',
        ISOCode: 'AU',
        TimeZone: 0,
        LanguageId: 'EN-US',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0001',
        AddressFormatName: 'Street;City_State_PostCode; Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'AUT',
        ShortName: 'Austria',
        LongName: 'Republic of Austria',
        ISOCode: 'AT',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0002',
        AddressFormatName: 'Street;PostCode_City;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'AZE',
        ShortName: 'Azerbaijan',
        LongName: 'Republic of Azerbaijan',
        ISOCode: 'AZ',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0007',
        AddressFormatName: 'Street;PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'BDI',
        ShortName: 'Burundi',
        LongName: 'Republic of Burundi',
        ISOCode: 'BI',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0003',
        AddressFormatName: 'Street;City,State_PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'BEL',
        ShortName: 'Belgium',
        LongName: 'Kingdom of Belgium',
        ISOCode: 'BE',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0002',
        AddressFormatName: 'Street;PostCode_City;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'BEN',
        ShortName: 'Benin',
        LongName: 'Republic of Benin',
        ISOCode: 'BJ',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0003',
        AddressFormatName: 'Street;City,State_PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'BES',
        ShortName: 'Bonaire',
        LongName: 'Public Body of Bonaire',
        ISOCode: 'BQ',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0002',
        AddressFormatName: 'Street;PostCode_City;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'BFA',
        ShortName: 'Burkina Faso',
        LongName: 'Burkina Faso',
        ISOCode: 'BF',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 3,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0006',
        AddressFormatName: 'Street;City;State;County;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'BGD',
        ShortName: 'Bangladesh',
        LongName: "People's Republic of Bangladesh",
        ISOCode: 'BD',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0001',
        AddressFormatName: 'Street;City_State_PostCode; Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'BGR',
        ShortName: 'Bulgaria',
        LongName: 'Republic of Bulgaria',
        ISOCode: 'BG',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0007',
        AddressFormatName: 'Street;PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'BHR',
        ShortName: 'Bahrain',
        LongName: 'Kingdom of Bahrain',
        ISOCode: 'BH',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0001',
        AddressFormatName: 'Street;City_State_PostCode; Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'BHS',
        ShortName: 'Bahamas, The',
        LongName: 'The Commonwealth of The Bahamas',
        ISOCode: 'BS',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 3,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0006',
        AddressFormatName: 'Street;City;State;County;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'BIH',
        ShortName: 'Bosnia and Herzegovina',
        LongName: 'Bosnia and Herzegovina',
        ISOCode: 'BA',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0003',
        AddressFormatName: 'Street;City,State_PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'BLM',
        ShortName: 'Saint Barth\u00E9lemy',
        LongName: 'Overseas Collectivity of Saint Barth\u00E9lemy',
        ISOCode: 'BL',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0004',
        AddressFormatName: 'Street;PostCode_City;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'BLR',
        ShortName: 'Belarus',
        LongName: 'Republic of Belarus',
        ISOCode: 'BY',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 3,
                LineNumber: 4,
                IsDataEntryOnly: true,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 6,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0008',
        AddressFormatName: 'Street;City,State_PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'BLZ',
        ShortName: 'Belize',
        LongName: 'Belize',
        ISOCode: 'BZ',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 3,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0006',
        AddressFormatName: 'Street;City;State;County;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'BMU',
        ShortName: 'Bermuda',
        LongName: 'Bermuda',
        ISOCode: 'BM',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0003',
        AddressFormatName: 'Street;City,State_PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'BOL',
        ShortName: 'Bolivia',
        LongName: 'Plurinational State of Bolivia',
        ISOCode: 'BO',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 8,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 9,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 3,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 6,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 7,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 8,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0012',
        AddressFormatName: 'Street_Number_Complement;County;City,State,PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'BRA',
        ShortName: 'Brazil',
        LongName: 'Federative Republic of Brazil',
        ISOCode: 'BR',
        TimeZone: 0,
        LanguageId: 'EN-US',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 8,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 9,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 10,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 7,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 6,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 7,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 8,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 9,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0010',
        AddressFormatName: 'Street_Number_Complement;Post_District;PostCode_City_State_Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'BRB',
        ShortName: 'Barbados',
        LongName: 'Barbados',
        ISOCode: 'BB',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 3,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0006',
        AddressFormatName: 'Street;City;State;County;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'BRN',
        ShortName: 'Brunei',
        LongName: 'Brunei Darussalam',
        ISOCode: 'BN',
        TimeZone: 0,
        LanguageId: 'EN-US',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0003',
        AddressFormatName: 'Street;City,State_PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'BTN',
        ShortName: 'Bhutan',
        LongName: 'Kingdom of Bhutan',
        ISOCode: 'BT',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 3,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0006',
        AddressFormatName: 'Street;City;State;County;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'BVT',
        ShortName: 'Bouvet Island',
        LongName: 'Bouvet Island',
        ISOCode: 'BV',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0001',
        AddressFormatName: 'Street;City_State_PostCode; Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'BWA',
        ShortName: 'Botswana',
        LongName: 'Republic of Botswana',
        ISOCode: 'BW',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0001',
        AddressFormatName: 'Street;City_State_PostCode; Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'CAF',
        ShortName: 'Central African Republic',
        LongName: 'Central African Republic',
        ISOCode: 'CF',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 3,
                LineNumber: 4,
                IsDataEntryOnly: true,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 6,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0008',
        AddressFormatName: 'Street;City,State_PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'CAN',
        ShortName: 'Canada',
        LongName: 'Canada',
        ISOCode: 'CA',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0003',
        AddressFormatName: 'Street;City,State_PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'CCK',
        ShortName: 'Cocos (Keeling) Islands',
        LongName: 'Territory of Cocos (Keeling) Islands',
        ISOCode: 'CC',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0001',
        AddressFormatName: 'Street;City_State_PostCode; Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'CHE',
        ShortName: 'Switzerland',
        LongName: 'Swiss Confederation',
        ISOCode: 'CH',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0002',
        AddressFormatName: 'Street;PostCode_City;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'CHL',
        ShortName: 'Chile',
        LongName: 'Republic of Chile',
        ISOCode: 'CL',
        TimeZone: 0,
        LanguageId: 'EN-US',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 8,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 9,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 3,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 6,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 7,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 8,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0012',
        AddressFormatName: 'Street_Number_Complement;County;City,State,PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'CHN',
        ShortName: 'China',
        LongName: "People's Republic of China",
        ISOCode: 'CN',
        TimeZone: 0,
        LanguageId: 'EN-US',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 9,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 6,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 3,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 7,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 6,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 7,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 8,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0018',
        AddressFormatName: 'PostCode;Country/Region_State_City_County_Street_District_Complement',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'CIV',
        ShortName: 'C\u00F4te d\u2019Ivoire',
        LongName: 'Republic of C\u00F4te d\u2019Ivoire',
        ISOCode: 'CI',
        TimeZone: 0,
        LanguageId: 'EN-US',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0004',
        AddressFormatName: 'Street;PostCode_City;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'CMR',
        ShortName: 'Cameroon',
        LongName: 'Republic of Cameroon',
        ISOCode: 'CM',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 3,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0006',
        AddressFormatName: 'Street;City;State;County;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'COD',
        ShortName: 'Congo (DRC)',
        LongName: 'Democratic Republic of the Congo',
        ISOCode: 'CD',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0001',
        AddressFormatName: 'Street;City_State_PostCode; Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'COG',
        ShortName: 'Congo',
        LongName: 'Republic of the Congo',
        ISOCode: 'CG',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0001',
        AddressFormatName: 'Street;City_State_PostCode; Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'COK',
        ShortName: 'Cook Islands',
        LongName: 'Cook Islands',
        ISOCode: 'CK',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0001',
        AddressFormatName: 'Street;City_State_PostCode; Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'COL',
        ShortName: 'Colombia',
        LongName: 'Republic of Colombia',
        ISOCode: 'CO',
        TimeZone: 0,
        LanguageId: 'EN-US',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 8,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 9,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 3,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 6,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 7,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 8,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0012',
        AddressFormatName: 'Street_Number_Complement;County;City,State,PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'COM',
        ShortName: 'Comoros',
        LongName: 'Union of the Comoros',
        ISOCode: 'KM',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 3,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0006',
        AddressFormatName: 'Street;City;State;County;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'CPV',
        ShortName: 'Cape Verde',
        LongName: 'Republic of Cape Verde',
        ISOCode: 'CV',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 3,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0006',
        AddressFormatName: 'Street;City;State;County;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'CRI',
        ShortName: 'Costa Rica',
        LongName: 'Republic of Costa Rica',
        ISOCode: 'CR',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 8,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 9,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 3,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 6,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 7,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 8,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0012',
        AddressFormatName: 'Street_Number_Complement;County;City,State,PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'CUB',
        ShortName: 'Cuba',
        LongName: 'Republic of Cuba',
        ISOCode: 'CU',
        TimeZone: 0,
        LanguageId: 'EN-US',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0001',
        AddressFormatName: 'Street;City_State_PostCode; Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'CUW',
        ShortName: 'Cura\u00E7ao',
        LongName: 'Country of Cura\u00E7ao',
        ISOCode: 'CW',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0001',
        AddressFormatName: 'Street;City_State_PostCode; Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'CXR',
        ShortName: 'Christmas Island',
        LongName: 'Territory of Christmas Island',
        ISOCode: 'CX',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0001',
        AddressFormatName: 'Street;City_State_PostCode; Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'CYM',
        ShortName: 'Cayman Islands',
        LongName: 'Cayman Islands',
        ISOCode: 'KY',
        TimeZone: 0,
        LanguageId: 'EN-US',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 3,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0006',
        AddressFormatName: 'Street;City;State;County;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'CYP',
        ShortName: 'Cyprus',
        LongName: 'Republic of Cyprus',
        ISOCode: 'CY',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0003',
        AddressFormatName: 'Street;City,State_PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'CZE',
        ShortName: 'Czech Republic',
        LongName: 'Czech Republic',
        ISOCode: 'CZ',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 9,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0016',
        AddressFormatName: 'Street_Complement;PostCode_City;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'DEU',
        ShortName: 'Germany',
        LongName: 'Federal Republic of Germany',
        ISOCode: 'DE',
        TimeZone: 0,
        LanguageId: 'EN-US',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0002',
        AddressFormatName: 'Street;PostCode_City;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'DJI',
        ShortName: 'Djibouti',
        LongName: 'Republic of Djibouti',
        ISOCode: 'DJ',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0001',
        AddressFormatName: 'Street;City_State_PostCode; Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'DMA',
        ShortName: 'Dominica',
        LongName: 'Commonwealth of Dominica',
        ISOCode: 'DM',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0001',
        AddressFormatName: 'Street;City_State_PostCode; Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'DNK',
        ShortName: 'Denmark',
        LongName: 'Kingdom of Denmark',
        ISOCode: 'DK',
        TimeZone: 0,
        LanguageId: 'EN-US',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0002',
        AddressFormatName: 'Street;PostCode_City;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'DOM',
        ShortName: 'Dominican Republic',
        LongName: 'Dominican Republic',
        ISOCode: 'DO',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 8,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 9,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 3,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 6,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 7,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 8,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0012',
        AddressFormatName: 'Street_Number_Complement;County;City,State,PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'DZA',
        ShortName: 'Algeria',
        LongName: "People's Democratic Republic of Algeria",
        ISOCode: 'DZ',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0001',
        AddressFormatName: 'Street;City_State_PostCode; Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'ECU',
        ShortName: 'Ecuador',
        LongName: 'Republic of Ecuador',
        ISOCode: 'EC',
        TimeZone: 0,
        LanguageId: 'EN-US',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 8,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 9,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 3,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 6,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 7,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 8,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0012',
        AddressFormatName: 'Street_Number_Complement;County;City,State,PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'EGY',
        ShortName: 'Egypt',
        LongName: 'Arab Republic of Egypt',
        ISOCode: 'EG',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0001',
        AddressFormatName: 'Street;City_State_PostCode; Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'ERI',
        ShortName: 'Eritrea',
        LongName: 'State of Eritrea',
        ISOCode: 'ER',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0001',
        AddressFormatName: 'Street;City_State_PostCode; Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'ESP',
        ShortName: 'Spain',
        LongName: 'Kingdom of Spain',
        ISOCode: 'ES',
        TimeZone: 0,
        LanguageId: 'EN-US',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0002',
        AddressFormatName: 'Street;PostCode_City;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'EST',
        ShortName: 'Estonia',
        LongName: 'Republic of Estonia',
        ISOCode: 'EE',
        TimeZone: 0,
        LanguageId: 'EN-US',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0003',
        AddressFormatName: 'Street;City,State_PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'ETH',
        ShortName: 'Ethiopia',
        LongName: 'Federal Democratic Republic of Ethiopia',
        ISOCode: 'ET',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0001',
        AddressFormatName: 'Street;City_State_PostCode; Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'FIN',
        ShortName: 'Finland',
        LongName: 'Republic of Finland',
        ISOCode: 'FI',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 10,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0009',
        AddressFormatName: 'Street;Post;City_PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'FJI',
        ShortName: 'Fiji',
        LongName: 'Republic of the Fiji Islands',
        ISOCode: 'FJ',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 3,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0006',
        AddressFormatName: 'Street;City;State;County;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'FLK',
        ShortName: 'Falkland Islands (Islas Malvinas)',
        LongName: 'Falkland Islands (Islas Malvinas)',
        ISOCode: 'FK',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 8,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 9,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 3,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 6,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 7,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 8,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0012',
        AddressFormatName: 'Street_Number_Complement;County;City,State,PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'FRA',
        ShortName: 'France',
        LongName: 'French Republic',
        ISOCode: 'FR',
        TimeZone: 0,
        LanguageId: 'EN-US',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0004',
        AddressFormatName: 'Street;PostCode_City;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'FRO',
        ShortName: 'Faroe Islands',
        LongName: 'Faroe Islands',
        ISOCode: 'FO',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 3,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 6,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0005',
        AddressFormatName: 'Street;City;State;County;PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'FSM',
        ShortName: 'Micronesia',
        LongName: 'Federated States of Micronesia',
        ISOCode: 'FM',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0003',
        AddressFormatName: 'Street;City,State_PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'GAB',
        ShortName: 'Gabon',
        LongName: 'Gabonese Republic',
        ISOCode: 'GA',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0003',
        AddressFormatName: 'Street;City,State_PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'GBR',
        ShortName: 'United Kingdom',
        LongName: 'United Kingdom of Great Britain and Northern Ireland',
        ISOCode: 'GB',
        TimeZone: 0,
        LanguageId: 'EN-US',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 3,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 6,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0005',
        AddressFormatName: 'Street;City;State;County;PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'GEO',
        ShortName: 'Georgia',
        LongName: 'Georgia',
        ISOCode: 'GE',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0003',
        AddressFormatName: 'Street;City,State_PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'GGY',
        ShortName: 'Guernsey',
        LongName: 'Bailiwick of Guernsey',
        ISOCode: 'GG',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 3,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 6,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0005',
        AddressFormatName: 'Street;City;State;County;PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'GHA',
        ShortName: 'Ghana',
        LongName: 'Republic of Ghana',
        ISOCode: 'GH',
        TimeZone: 0,
        LanguageId: 'EN-US',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0003',
        AddressFormatName: 'Street;City,State_PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'GIB',
        ShortName: 'Gibraltar',
        LongName: 'Gibraltar',
        ISOCode: 'GI',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 3,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0006',
        AddressFormatName: 'Street;City;State;County;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'GIN',
        ShortName: 'Guinea',
        LongName: 'Republic of Guinea',
        ISOCode: 'GN',
        TimeZone: 0,
        LanguageId: 'EN-US',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 3,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0006',
        AddressFormatName: 'Street;City;State;County;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'GLP',
        ShortName: 'Guadeloupe',
        LongName: 'Guadeloupe',
        ISOCode: 'GP',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0003',
        AddressFormatName: 'Street;City,State_PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'GMB',
        ShortName: 'Gambia',
        LongName: 'Republic of The Gambia',
        ISOCode: 'GM',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0003',
        AddressFormatName: 'Street;City,State_PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'GNB',
        ShortName: 'Guinea-Bissau',
        LongName: 'Republic of Guinea-Bissau',
        ISOCode: 'GW',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0003',
        AddressFormatName: 'Street;City,State_PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'GNQ',
        ShortName: 'Equatorial Guinea',
        LongName: 'Republic of Equatorial Guinea',
        ISOCode: 'GQ',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0001',
        AddressFormatName: 'Street;City_State_PostCode; Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'GRC',
        ShortName: 'Greece',
        LongName: 'Hellenic Republic',
        ISOCode: 'GR',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 3,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 6,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0005',
        AddressFormatName: 'Street;City;State;County;PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'GRD',
        ShortName: 'Grenada',
        LongName: 'Grenada',
        ISOCode: 'GD',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 3,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0006',
        AddressFormatName: 'Street;City;State;County;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'GRL',
        ShortName: 'Greenland',
        LongName: 'Greenland',
        ISOCode: 'GL',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0003',
        AddressFormatName: 'Street;City,State_PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'GTM',
        ShortName: 'Guatemala',
        LongName: 'Republic of Guatemala',
        ISOCode: 'GT',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 8,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 9,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 3,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 6,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 7,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 8,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0012',
        AddressFormatName: 'Street_Number_Complement;County;City,State,PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'GUF',
        ShortName: 'French Guiana',
        LongName: 'French Guiana',
        ISOCode: 'GF',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 3,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 6,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0005',
        AddressFormatName: 'Street;City;State;County;PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'GUM',
        ShortName: 'Guam',
        LongName: 'Territory of Guam',
        ISOCode: 'GU',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0003',
        AddressFormatName: 'Street;City,State_PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'GUY',
        ShortName: 'Guyana',
        LongName: 'Cooperative Republic of Guyana',
        ISOCode: 'GY',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 8,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 9,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 3,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 6,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 7,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 8,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0012',
        AddressFormatName: 'Street_Number_Complement;County;City,State,PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'HKG',
        ShortName: 'Hong Kong SAR',
        LongName: 'Hong Kong Special Administrative Region',
        ISOCode: 'HK',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 3,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0006',
        AddressFormatName: 'Street;City;State;County;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'HMD',
        ShortName: 'Heard Island and McDonald Islands',
        LongName: 'Territory of Heard Island and McDonald Islands',
        ISOCode: 'HM',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0001',
        AddressFormatName: 'Street;City_State_PostCode; Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'HND',
        ShortName: 'Honduras',
        LongName: 'Republic of Honduras',
        ISOCode: 'HN',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 8,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 9,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 3,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 6,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 7,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 8,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0012',
        AddressFormatName: 'Street_Number_Complement;County;City,State,PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'HRV',
        ShortName: 'Croatia',
        LongName: 'Republic of Croatia',
        ISOCode: 'HR',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0003',
        AddressFormatName: 'Street;City,State_PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'HTI',
        ShortName: 'Haiti',
        LongName: 'Republic of Haiti',
        ISOCode: 'HT',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 8,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 9,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 3,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 6,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 7,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 8,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0012',
        AddressFormatName: 'Street_Number_Complement;County;City,State,PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'HUN',
        ShortName: 'Hungary',
        LongName: 'Republic of Hungary',
        ISOCode: 'HU',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 1,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 6,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 9,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0017',
        AddressFormatName: 'PostCode_City;Street_Complement;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'IDN',
        ShortName: 'Indonesia',
        LongName: 'Republic of Indonesia',
        ISOCode: 'ID',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0003',
        AddressFormatName: 'Street;City,State_PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'IMN',
        ShortName: 'Isle of Man',
        LongName: 'Isle of Man',
        ISOCode: 'IM',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 3,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 6,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0005',
        AddressFormatName: 'Street;City;State;County;PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'IND',
        ShortName: 'India',
        LongName: 'Republic of India',
        ISOCode: 'IN',
        TimeZone: 0,
        LanguageId: 'EN-US',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 9,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 6,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 10,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 7,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' - ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 6,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 3,
                LineNumber: 7,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 8,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 9,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0015',
        AddressFormatName: 'Street;Complement;Post;County_District,State;City,PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'IOT',
        ShortName: 'British Indian Ocean Territory',
        LongName: 'British Indian Ocean Territory',
        ISOCode: 'IO',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 3,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 6,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0005',
        AddressFormatName: 'Street;City;State;County;PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'IRL',
        ShortName: 'Ireland',
        LongName: 'Ireland',
        ISOCode: 'IE',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 3,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0006',
        AddressFormatName: 'Street;City;State;County;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'IRN',
        ShortName: 'Iran',
        LongName: 'Islamic Republic of Iran',
        ISOCode: 'IR',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0001',
        AddressFormatName: 'Street;City_State_PostCode; Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'IRQ',
        ShortName: 'Iraq',
        LongName: 'Republic of Iraq',
        ISOCode: 'IQ',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0001',
        AddressFormatName: 'Street;City_State_PostCode; Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'ISL',
        ShortName: 'Iceland',
        LongName: 'Republic of Iceland',
        ISOCode: 'IS',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0002',
        AddressFormatName: 'Street;PostCode_City;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'ISR',
        ShortName: 'Israel',
        LongName: 'State of Israel',
        ISOCode: 'IL',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0013',
        AddressFormatName: 'Street;City,PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'ITA',
        ShortName: 'Italy',
        LongName: 'Italian Republic',
        ISOCode: 'IT',
        TimeZone: 0,
        LanguageId: 'EN-US',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0003',
        AddressFormatName: 'Street;City,State_PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'JAM',
        ShortName: 'Jamaica',
        LongName: 'Jamaica',
        ISOCode: 'JM',
        TimeZone: 0,
        LanguageId: 'EN-US',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 8,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 9,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 3,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 6,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 7,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 8,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0012',
        AddressFormatName: 'Street_Number_Complement;County;City,State,PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'JEY',
        ShortName: 'Jersey',
        LongName: 'Bailiwick of Jersey',
        ISOCode: 'JE',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0001',
        AddressFormatName: 'Street;City_State_PostCode; Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'JOR',
        ShortName: 'Jordan',
        LongName: 'Hashemite Kingdom of Jordan',
        ISOCode: 'JO',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 3,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 6,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0005',
        AddressFormatName: 'Street;City;State;County;PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'JPN',
        ShortName: 'Japan',
        LongName: 'Japan',
        ISOCode: 'JP',
        TimeZone: 0,
        LanguageId: 'EN-US',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0003',
        AddressFormatName: 'Street;City,State_PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'KAZ',
        ShortName: 'Kazakhstan',
        LongName: 'Republic of Kazakhstan',
        ISOCode: 'KZ',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 3,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0006',
        AddressFormatName: 'Street;City;State;County;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'KEN',
        ShortName: 'Kenya',
        LongName: 'Republic of Kenya',
        ISOCode: 'KE',
        TimeZone: 0,
        LanguageId: 'EN-US',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 3,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0006',
        AddressFormatName: 'Street;City;State;County;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'KGZ',
        ShortName: 'Kyrgyzstan',
        LongName: 'Kyrgyz Republic',
        ISOCode: 'KG',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0003',
        AddressFormatName: 'Street;City,State_PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'KHM',
        ShortName: 'Cambodia',
        LongName: 'Kingdom of Cambodia',
        ISOCode: 'KH',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 3,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0006',
        AddressFormatName: 'Street;City;State;County;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'KIR',
        ShortName: 'Kiribati',
        LongName: 'Republic of Kiribati',
        ISOCode: 'KI',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0001',
        AddressFormatName: 'Street;City_State_PostCode; Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'KNA',
        ShortName: 'Saint Kitts and Nevis',
        LongName: 'Federation of Saint Kitts and Nevis',
        ISOCode: 'KN',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0001',
        AddressFormatName: 'Street;City_State_PostCode; Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'KOR',
        ShortName: 'Korea',
        LongName: 'Republic of Korea',
        ISOCode: 'KR',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0001',
        AddressFormatName: 'Street;City_State_PostCode; Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'KWT',
        ShortName: 'Kuwait',
        LongName: 'State of Kuwait',
        ISOCode: 'KW',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0003',
        AddressFormatName: 'Street;City,State_PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'LAO',
        ShortName: 'Laos',
        LongName: "Lao People's Democratic Republic",
        ISOCode: 'LA',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0001',
        AddressFormatName: 'Street;City_State_PostCode; Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'LBN',
        ShortName: 'Lebanon',
        LongName: 'Lebanese Republic',
        ISOCode: 'LB',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 3,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0006',
        AddressFormatName: 'Street;City;State;County;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'LBR',
        ShortName: 'Liberia',
        LongName: 'Republic of Liberia',
        ISOCode: 'LR',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0003',
        AddressFormatName: 'Street;City,State_PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'LBY',
        ShortName: 'Libya',
        LongName: "Great Socialist People's Libyan Arab Jamahiriya",
        ISOCode: 'LY',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0001',
        AddressFormatName: 'Street;City_State_PostCode; Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'LCA',
        ShortName: 'Saint Lucia',
        LongName: 'Saint Lucia',
        ISOCode: 'LC',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0001',
        AddressFormatName: 'Street;City_State_PostCode; Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'LIE',
        ShortName: 'Liechtenstein',
        LongName: 'Principality of Liechtenstein',
        ISOCode: 'LI',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0003',
        AddressFormatName: 'Street;City,State_PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'LKA',
        ShortName: 'Sri Lanka',
        LongName: 'Democratic Socialist Republic of Sri Lanka',
        ISOCode: 'LK',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0001',
        AddressFormatName: 'Street;City_State_PostCode; Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'LSO',
        ShortName: 'Lesotho',
        LongName: 'Kingdom of Lesotho',
        ISOCode: 'LS',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0003',
        AddressFormatName: 'Street;City,State_PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'LTU',
        ShortName: 'Lithuania',
        LongName: 'Republic of Lithuania',
        ISOCode: 'LT',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0003',
        AddressFormatName: 'Street;City,State_PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'LUX',
        ShortName: 'Luxembourg',
        LongName: 'Grand Duchy of Luxembourg',
        ISOCode: 'LU',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0003',
        AddressFormatName: 'Street;City,State_PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'LVA',
        ShortName: 'Latvia',
        LongName: 'Republic of Latvia',
        ISOCode: 'LV',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0003',
        AddressFormatName: 'Street;City,State_PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'MAC',
        ShortName: 'Macao SAR',
        LongName: 'Macao Special Administrative Region',
        ISOCode: 'MO',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0001',
        AddressFormatName: 'Street;City_State_PostCode; Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'MAF',
        ShortName: 'Saint Martin',
        LongName: 'Overseas Collectivity of Saint Martin',
        ISOCode: 'MF',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0004',
        AddressFormatName: 'Street;PostCode_City;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'MAR',
        ShortName: 'Morocco',
        LongName: 'Kingdom of Morocco',
        ISOCode: 'MA',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0001',
        AddressFormatName: 'Street;City_State_PostCode; Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'MCO',
        ShortName: 'Monaco',
        LongName: 'Principality of Monaco',
        ISOCode: 'MC',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0003',
        AddressFormatName: 'Street;City,State_PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'MDA',
        ShortName: 'Moldova',
        LongName: 'Republic of Moldova',
        ISOCode: 'MD',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0003',
        AddressFormatName: 'Street;City,State_PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'MDG',
        ShortName: 'Madagascar',
        LongName: 'Republic of Madagascar',
        ISOCode: 'MG',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 3,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0006',
        AddressFormatName: 'Street;City;State;County;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'MDV',
        ShortName: 'Maldives',
        LongName: 'Republic of Maldives',
        ISOCode: 'MV',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0001',
        AddressFormatName: 'Street;City_State_PostCode; Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'MEX',
        ShortName: 'Mexico',
        LongName: 'United Mexican States',
        ISOCode: 'MX',
        TimeZone: 0,
        LanguageId: 'EN-US',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 8,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 9,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 3,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 6,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 7,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 8,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0012',
        AddressFormatName: 'Street_Number_Complement;County;City,State,PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'MHL',
        ShortName: 'Marshall Islands',
        LongName: 'Republic of the Marshall Islands',
        ISOCode: 'MH',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0003',
        AddressFormatName: 'Street;City,State_PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'MKD',
        ShortName: 'Macedonia, Former Yugoslav Republic of',
        LongName: 'Republic of Macedonia',
        ISOCode: 'MK',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0003',
        AddressFormatName: 'Street;City,State_PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'MLI',
        ShortName: 'Mali',
        LongName: 'Republic of Mali',
        ISOCode: 'ML',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0003',
        AddressFormatName: 'Street;City,State_PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'MLT',
        ShortName: 'Malta',
        LongName: 'Republic of Malta',
        ISOCode: 'MT',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0003',
        AddressFormatName: 'Street;City,State_PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'MMR',
        ShortName: 'Myanmar',
        LongName: 'Union of Myanmar',
        ISOCode: 'MM',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0001',
        AddressFormatName: 'Street;City_State_PostCode; Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'MNE',
        ShortName: 'Montenegro',
        LongName: 'Montenegro',
        ISOCode: 'ME',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0003',
        AddressFormatName: 'Street;City,State_PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'MNG',
        ShortName: 'Mongolia',
        LongName: 'Mongolia',
        ISOCode: 'MN',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0001',
        AddressFormatName: 'Street;City_State_PostCode; Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'MNP',
        ShortName: 'Northern Mariana Islands',
        LongName: 'Commonwealth of the Northern Mariana Islands',
        ISOCode: 'MP',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0001',
        AddressFormatName: 'Street;City_State_PostCode; Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'MOZ',
        ShortName: 'Mozambique',
        LongName: 'Republic of Mozambique',
        ISOCode: 'MZ',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0003',
        AddressFormatName: 'Street;City,State_PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'MRT',
        ShortName: 'Mauritania',
        LongName: 'Islamic Republic of Mauritania',
        ISOCode: 'MR',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0001',
        AddressFormatName: 'Street;City_State_PostCode; Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'MSR',
        ShortName: 'Montserrat',
        LongName: 'Montserrat',
        ISOCode: 'MS',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0001',
        AddressFormatName: 'Street;City_State_PostCode; Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'MTQ',
        ShortName: 'Martinique',
        LongName: 'Martinique',
        ISOCode: 'MQ',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0003',
        AddressFormatName: 'Street;City,State_PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'MUS',
        ShortName: 'Mauritius',
        LongName: 'Republic of Mauritius',
        ISOCode: 'MU',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0001',
        AddressFormatName: 'Street;City_State_PostCode; Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'MWI',
        ShortName: 'Malawi',
        LongName: 'Republic of Malawi',
        ISOCode: 'MW',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 3,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0006',
        AddressFormatName: 'Street;City;State;County;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'MYS',
        ShortName: 'Malaysia',
        LongName: 'Malaysia',
        ISOCode: 'MY',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0003',
        AddressFormatName: 'Street;City,State_PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'MYT',
        ShortName: 'Mayotte',
        LongName: 'Overseas Community of Mayotte',
        ISOCode: 'YT',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0003',
        AddressFormatName: 'Street;City,State_PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'NAM',
        ShortName: 'Namibia',
        LongName: 'Republic of Namibia',
        ISOCode: 'NA',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0001',
        AddressFormatName: 'Street;City_State_PostCode; Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'NCL',
        ShortName: 'New Caledonia',
        LongName: 'Territory of New Caledonia and Dependencies',
        ISOCode: 'NC',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0003',
        AddressFormatName: 'Street;City,State_PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'NER',
        ShortName: 'Niger',
        LongName: 'Republic of Niger',
        ISOCode: 'NE',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0001',
        AddressFormatName: 'Street;City_State_PostCode; Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'NFK',
        ShortName: 'Norfolk Island',
        LongName: 'Territory of Norfolk Island',
        ISOCode: 'NF',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0003',
        AddressFormatName: 'Street;City,State_PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'NGA',
        ShortName: 'Nigeria',
        LongName: 'Federal Republic of Nigeria',
        ISOCode: 'NG',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0001',
        AddressFormatName: 'Street;City_State_PostCode; Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'NIC',
        ShortName: 'Nicaragua',
        LongName: 'Republic of Nicaragua',
        ISOCode: 'NI',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 8,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 9,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 3,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 6,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 7,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 8,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0012',
        AddressFormatName: 'Street_Number_Complement;County;City,State,PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'NIU',
        ShortName: 'Niue',
        LongName: 'Republic of Niue',
        ISOCode: 'NU',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0001',
        AddressFormatName: 'Street;City_State_PostCode; Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'NLD',
        ShortName: 'Netherlands',
        LongName: 'Kingdom of the Netherlands',
        ISOCode: 'NL',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0002',
        AddressFormatName: 'Street;PostCode_City;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'NOR',
        ShortName: 'Norway',
        LongName: 'Kingdom of Norway',
        ISOCode: 'NO',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0004',
        AddressFormatName: 'Street;PostCode_City;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'NPL',
        ShortName: 'Nepal',
        LongName: 'Federal Democratic Republic of Nepal',
        ISOCode: 'NP',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0001',
        AddressFormatName: 'Street;City_State_PostCode; Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'NRU',
        ShortName: 'Nauru',
        LongName: 'Republic of Nauru',
        ISOCode: 'NR',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0001',
        AddressFormatName: 'Street;City_State_PostCode; Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'NZL',
        ShortName: 'New Zealand',
        LongName: 'New Zealand',
        ISOCode: 'NZ',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0001',
        AddressFormatName: 'Street;City_State_PostCode; Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'OMN',
        ShortName: 'Oman',
        LongName: 'Sultanate of Oman',
        ISOCode: 'OM',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0001',
        AddressFormatName: 'Street;City_State_PostCode; Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'PAK',
        ShortName: 'Pakistan',
        LongName: 'Islamic Republic of Pakistan',
        ISOCode: 'PK',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0003',
        AddressFormatName: 'Street;City,State_PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'PAN',
        ShortName: 'Panama',
        LongName: 'Republic of Panama',
        ISOCode: 'PA',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 8,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 9,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 3,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 6,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 7,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 8,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0012',
        AddressFormatName: 'Street_Number_Complement;County;City,State,PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'PCN',
        ShortName: 'Pitcairn Islands',
        LongName: 'Pitcairn, Henderson, Ducie, and Oeno Islands',
        ISOCode: 'PN',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0001',
        AddressFormatName: 'Street;City_State_PostCode; Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'PER',
        ShortName: 'Peru',
        LongName: 'Republic of Peru',
        ISOCode: 'PE',
        TimeZone: 0,
        LanguageId: 'EN-US',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 8,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 9,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 3,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 6,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 7,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 8,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0012',
        AddressFormatName: 'Street_Number_Complement;County;City,State,PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'PHL',
        ShortName: 'Philippines',
        LongName: 'Republic of the Philippines',
        ISOCode: 'PH',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0001',
        AddressFormatName: 'Street;City_State_PostCode; Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'PLW',
        ShortName: 'Palau',
        LongName: 'Republic of Palau',
        ISOCode: 'PW',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0003',
        AddressFormatName: 'Street;City,State_PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'PNG',
        ShortName: 'Papua New Guinea',
        LongName: 'Independent State of Papua New Guinea',
        ISOCode: 'PG',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0003',
        AddressFormatName: 'Street;City,State_PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'POL',
        ShortName: 'Poland',
        LongName: 'Republic of Poland',
        ISOCode: 'PL',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 9,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0016',
        AddressFormatName: 'Street_Complement;PostCode_City;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'PRI',
        ShortName: 'Puerto Rico',
        LongName: 'Commonwealth of Puerto Rico',
        ISOCode: 'PR',
        TimeZone: 0,
        LanguageId: 'EN-US',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0004',
        AddressFormatName: 'Street;PostCode_City;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'PRK',
        ShortName: 'North Korea',
        LongName: "Democratic People's Republic of Korea",
        ISOCode: 'KP',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0001',
        AddressFormatName: 'Street;City_State_PostCode; Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'PRT',
        ShortName: 'Portugal',
        LongName: 'Portuguese Republic',
        ISOCode: 'PT',
        TimeZone: 0,
        LanguageId: 'EN-US',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0003',
        AddressFormatName: 'Street;City,State_PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'PRY',
        ShortName: 'Paraguay',
        LongName: 'Republic of Paraguay',
        ISOCode: 'PY',
        TimeZone: 0,
        LanguageId: 'EN-US',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 8,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 9,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 3,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 6,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 7,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 8,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0012',
        AddressFormatName: 'Street_Number_Complement;County;City,State,PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'PSE',
        ShortName: 'Palestinian Authority',
        LongName: 'Palestinian National Authority',
        ISOCode: 'PS',
        TimeZone: 0,
        LanguageId: 'EN-US',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0001',
        AddressFormatName: 'Street;City_State_PostCode; Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'PYF',
        ShortName: 'French Polynesia',
        LongName: 'Overseas Lands of French Polynesia',
        ISOCode: 'PF',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 3,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 6,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0005',
        AddressFormatName: 'Street;City;State;County;PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'QAT',
        ShortName: 'Qatar',
        LongName: 'State of Qatar',
        ISOCode: 'QA',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0003',
        AddressFormatName: 'Street;City,State_PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'REU',
        ShortName: 'Reunion',
        LongName: 'Reunion',
        ISOCode: 'RE',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0003',
        AddressFormatName: 'Street;City,State_PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'ROU',
        ShortName: 'Romania',
        LongName: 'Romania',
        ISOCode: 'RO',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0001',
        AddressFormatName: 'Street;City_State_PostCode; Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'RUS',
        ShortName: 'Russia',
        LongName: 'Russian Federation',
        ISOCode: 'RU',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 5,
                LineNumber: -1,
                IsDataEntryOnly: true,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 0,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: ',',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: true,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: ',',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 3,
                LineNumber: 2,
                IsDataEntryOnly: true,
                NewLine: false,
                Expand: true,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: ',',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: true,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: ',',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 7,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: true,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: ',',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 26,
                LineNumber: 5,
                IsDataEntryOnly: true,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: ',',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 6,
                LineNumber: 6,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: true,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: ',',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 9,
                LineNumber: 7,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: ',',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 24,
                LineNumber: 8,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: ',',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 25,
                LineNumber: 9,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 21,
                LineNumber: 10,
                IsDataEntryOnly: true,
                NewLine: false,
                Expand: true,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 22,
                LineNumber: 11,
                IsDataEntryOnly: true,
                NewLine: false,
                Expand: true,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '\u0420\u043E\u0441\u0441\u0438\u044F',
        AddressFormatName: '\u0420\u0424',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'RWA',
        ShortName: 'Rwanda',
        LongName: 'Republic of Rwanda',
        ISOCode: 'RW',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0001',
        AddressFormatName: 'Street;City_State_PostCode; Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'SAU',
        ShortName: 'Saudi Arabia',
        LongName: 'Kingdom of Saudi Arabia',
        ISOCode: 'SA',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 10,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0009',
        AddressFormatName: 'Street;Post;City_PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'SDN',
        ShortName: 'Sudan',
        LongName: 'Republic of the Sudan',
        ISOCode: 'SD',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0003',
        AddressFormatName: 'Street;City,State_PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'SEN',
        ShortName: 'Senegal',
        LongName: 'Republic of Senegal',
        ISOCode: 'SN',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0003',
        AddressFormatName: 'Street;City,State_PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'SGP',
        ShortName: 'Singapore',
        LongName: 'Republic of Singapore',
        ISOCode: 'SG',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 3,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0006',
        AddressFormatName: 'Street;City;State;County;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'SGS',
        ShortName: 'South Georgia and the South Sandwich Islands',
        LongName: 'South Georgia and the South Sandwich Islands',
        ISOCode: 'GS',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 3,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 6,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0005',
        AddressFormatName: 'Street;City;State;County;PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'SHN',
        ShortName: 'Saint Helena, Ascension and Tristan da Cunha',
        LongName: 'Saint Helena, Ascension and Tristan da Cunha',
        ISOCode: 'SH',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0001',
        AddressFormatName: 'Street;City_State_PostCode; Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'SJM',
        ShortName: 'Svalbard and Jan Mayen Island',
        LongName: 'Svalbard and Jan Mayen Island',
        ISOCode: 'SJ',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0004',
        AddressFormatName: 'Street;PostCode_City;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'SLB',
        ShortName: 'Solomon Islands',
        LongName: 'Solomon Islands',
        ISOCode: 'SB',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0001',
        AddressFormatName: 'Street;City_State_PostCode; Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'SLE',
        ShortName: 'Sierra Leone',
        LongName: 'Republic of Sierra Leone',
        ISOCode: 'SL',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0001',
        AddressFormatName: 'Street;City_State_PostCode; Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'SLV',
        ShortName: 'El Salvador',
        LongName: 'Republic of El Salvador',
        ISOCode: 'SV',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 8,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 9,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 3,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 6,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 7,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 8,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0012',
        AddressFormatName: 'Street_Number_Complement;County;City,State,PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'SMR',
        ShortName: 'San Marino',
        LongName: 'Republic of San Marino',
        ISOCode: 'SM',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0001',
        AddressFormatName: 'Street;City_State_PostCode; Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'SOM',
        ShortName: 'Somalia',
        LongName: 'Somali Republic',
        ISOCode: 'SO',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0001',
        AddressFormatName: 'Street;City_State_PostCode; Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'SPM',
        ShortName: 'Saint Pierre and Miquelon',
        LongName: 'Overseas Collectivity of Saint Pierre and Miquelon',
        ISOCode: 'PM',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0003',
        AddressFormatName: 'Street;City,State_PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'SRB',
        ShortName: 'Serbia',
        LongName: 'Republic of Serbia',
        ISOCode: 'RS',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0003',
        AddressFormatName: 'Street;City,State_PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'SSD',
        ShortName: 'South Sudan',
        LongName: 'Republic of South Sudan',
        ISOCode: 'SS',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0003',
        AddressFormatName: 'Street;City,State_PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'STP',
        ShortName: 'S\u00E3o Tom\u00E9 and Pr\u00EDncipe',
        LongName: 'Democratic Republic of S\u00E3o Tom\u00E9 and Pr\u00EDncipe',
        ISOCode: 'ST',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0001',
        AddressFormatName: 'Street;City_State_PostCode; Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'SUR',
        ShortName: 'Suriname',
        LongName: 'Republic of Suriname',
        ISOCode: 'SR',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 3,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0006',
        AddressFormatName: 'Street;City;State;County;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'SVK',
        ShortName: 'Slovakia',
        LongName: 'Slovak Republic',
        ISOCode: 'SK',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 3,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0006',
        AddressFormatName: 'Street;City;State;County;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'SVN',
        ShortName: 'Slovenia',
        LongName: 'Republic of Slovenia',
        ISOCode: 'SI',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 3,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0006',
        AddressFormatName: 'Street;City;State;County;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'SWE',
        ShortName: 'Sweden',
        LongName: 'Kingdom of Sweden',
        ISOCode: 'SE',
        TimeZone: 0,
        LanguageId: 'EN-US',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 10,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0009',
        AddressFormatName: 'Street;Post;City_PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'SWZ',
        ShortName: 'Swaziland',
        LongName: 'Kingdom of Swaziland',
        ISOCode: 'SZ',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0001',
        AddressFormatName: 'Street;City_State_PostCode; Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'SXM',
        ShortName: 'Sint Maarten',
        LongName: 'Country of Sint Maarten',
        ISOCode: 'SX',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0001',
        AddressFormatName: 'Street;City_State_PostCode; Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'SYC',
        ShortName: 'Seychelles',
        LongName: 'Republic of Seychelles',
        ISOCode: 'SC',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0001',
        AddressFormatName: 'Street;City_State_PostCode; Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'SYR',
        ShortName: 'Syria',
        LongName: 'Syrian Arab Republic',
        ISOCode: 'SY',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0001',
        AddressFormatName: 'Street;City_State_PostCode; Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'TCA',
        ShortName: 'Turks and Caicos Islands',
        LongName: 'Turks and Caicos Islands',
        ISOCode: 'TC',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0001',
        AddressFormatName: 'Street;City_State_PostCode; Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'TCD',
        ShortName: 'Chad',
        LongName: 'Republic of Chad',
        ISOCode: 'TD',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0004',
        AddressFormatName: 'Street;PostCode_City;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'TGO',
        ShortName: 'Togo',
        LongName: 'Togolese Republic',
        ISOCode: 'TG',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 3,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0006',
        AddressFormatName: 'Street;City;State;County;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'THA',
        ShortName: 'Thailand',
        LongName: 'Kingdom of Thailand',
        ISOCode: 'TH',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0003',
        AddressFormatName: 'Street;City,State_PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'TJK',
        ShortName: 'Tajikistan',
        LongName: 'Republic of Tajikistan',
        ISOCode: 'TJ',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0003',
        AddressFormatName: 'Street;City,State_PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'TKL',
        ShortName: 'Tokelau',
        LongName: 'Tokelau',
        ISOCode: 'TK',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0001',
        AddressFormatName: 'Street;City_State_PostCode; Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'TKM',
        ShortName: 'Turkmenistan',
        LongName: 'Turkmenistan',
        ISOCode: 'TM',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0001',
        AddressFormatName: 'Street;City_State_PostCode; Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'TLS',
        ShortName: 'Timor-Leste',
        LongName: 'Democratic Republic of Timor-Leste',
        ISOCode: 'TL',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0001',
        AddressFormatName: 'Street;City_State_PostCode; Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'TON',
        ShortName: 'Tonga',
        LongName: 'Kingdom of Tonga',
        ISOCode: 'TO',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0001',
        AddressFormatName: 'Street;City_State_PostCode; Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'TTO',
        ShortName: 'Trinidad and Tobago',
        LongName: 'Republic of Trinidad and Tobago',
        ISOCode: 'TT',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0001',
        AddressFormatName: 'Street;City_State_PostCode; Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'TUN',
        ShortName: 'Tunisia',
        LongName: 'Tunisian Republic',
        ISOCode: 'TN',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0003',
        AddressFormatName: 'Street;City,State_PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'TUR',
        ShortName: 'Turkey',
        LongName: 'Republic of Turkey',
        ISOCode: 'TR',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0003',
        AddressFormatName: 'Street;City,State_PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'TUV',
        ShortName: 'Tuvalu',
        LongName: 'Tuvalu',
        ISOCode: 'TV',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0001',
        AddressFormatName: 'Street;City_State_PostCode; Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'TWN',
        ShortName: 'Taiwan',
        LongName: 'Taiwan',
        ISOCode: 'TW',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 9,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 6,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 3,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 7,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 6,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 7,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 8,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0018',
        AddressFormatName: 'PostCode;Country/Region_State_City_County_Street_District_Complement',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'TZA',
        ShortName: 'Tanzania',
        LongName: 'United Republic of Tanzania',
        ISOCode: 'TZ',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0001',
        AddressFormatName: 'Street;City_State_PostCode; Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'UGA',
        ShortName: 'Uganda',
        LongName: 'Republic of Uganda',
        ISOCode: 'UG',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0003',
        AddressFormatName: 'Street;City,State_PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'UKR',
        ShortName: 'Ukraine',
        LongName: 'Ukraine',
        ISOCode: 'UA',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0003',
        AddressFormatName: 'Street;City,State_PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'UMI',
        ShortName: 'U.S. Minor Outlying Islands',
        LongName: 'United States Minor Outlying Islands',
        ISOCode: 'UM',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 3,
                LineNumber: 4,
                IsDataEntryOnly: true,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 6,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0008',
        AddressFormatName: 'Street;City,State_PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'URY',
        ShortName: 'Uruguay',
        LongName: 'Oriental Republic of Uruguay',
        ISOCode: 'UY',
        TimeZone: 0,
        LanguageId: 'EN-US',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 8,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 9,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 3,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 6,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 7,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 8,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0012',
        AddressFormatName: 'Street_Number_Complement;County;City,State,PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'USA',
        ShortName: 'United States',
        LongName: 'United States of America',
        ISOCode: 'US',
        TimeZone: 0,
        LanguageId: 'EN-US',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 3,
                LineNumber: 4,
                IsDataEntryOnly: true,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 6,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0008',
        AddressFormatName: 'Street;City,State_PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'UZB',
        ShortName: 'Uzbekistan',
        LongName: 'Republic of Uzbekistan',
        ISOCode: 'UZ',
        TimeZone: 0,
        LanguageId: 'EN-US',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 3,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0006',
        AddressFormatName: 'Street;City;State;County;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'VAT',
        ShortName: 'Vatican City',
        LongName: 'State of Vatican City',
        ISOCode: 'VA',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0003',
        AddressFormatName: 'Street;City,State_PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'VCT',
        ShortName: 'Saint Vincent and the Grenadines',
        LongName: 'Saint Vincent and the Grenadines',
        ISOCode: 'VC',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0001',
        AddressFormatName: 'Street;City_State_PostCode; Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'VEN',
        ShortName: 'Venezuela',
        LongName: 'Bolivarian Republic of Venezuela',
        ISOCode: 'VE',
        TimeZone: 0,
        LanguageId: 'EN-US',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 8,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 9,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 3,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 6,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 7,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 8,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0012',
        AddressFormatName: 'Street_Number_Complement;County;City,State,PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'VGB',
        ShortName: 'British Virgin Islands',
        LongName: 'British Virgin Islands',
        ISOCode: 'VG',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0001',
        AddressFormatName: 'Street;City_State_PostCode; Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'VIR',
        ShortName: 'Virgin Islands',
        LongName: 'Virgin Islands of the United States',
        ISOCode: 'VI',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0003',
        AddressFormatName: 'Street;City,State_PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'VNM',
        ShortName: 'Vietnam',
        LongName: 'Socialist Republic of Vietnam',
        ISOCode: 'VN',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 3,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 6,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0005',
        AddressFormatName: 'Street;City;State;County;PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'VUT',
        ShortName: 'Vanuatu',
        LongName: 'Republic of Vanuatu',
        ISOCode: 'VU',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0001',
        AddressFormatName: 'Street;City_State_PostCode; Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'WLF',
        ShortName: 'Wallis and Futuna',
        LongName: 'Overseas Collectivity of the Wallis and Futuna Islands',
        ISOCode: 'WF',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0003',
        AddressFormatName: 'Street;City,State_PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'WSM',
        ShortName: 'Samoa',
        LongName: 'Independent State of Samoa',
        ISOCode: 'WS',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 3,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0006',
        AddressFormatName: 'Street;City;State;County;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'XJA',
        ShortName: 'Jan Mayen',
        LongName: 'Jan Mayen',
        ISOCode: 'XJ',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0004',
        AddressFormatName: 'Street;PostCode_City;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'XKS',
        ShortName: 'Kosovo',
        LongName: 'Kosovo',
        ISOCode: 'XK',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ', ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0003',
        AddressFormatName: 'Street;City,State_PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'XSE',
        ShortName: 'Sint Eustatius',
        LongName: 'Public Body of Sint Eustatius',
        ISOCode: 'XE',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0002',
        AddressFormatName: 'Street;PostCode_City;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'YEM',
        ShortName: 'Yemen',
        LongName: 'Republic of Yemen',
        ISOCode: 'YE',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0001',
        AddressFormatName: 'Street;City_State_PostCode; Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'ZAF',
        ShortName: 'South Africa',
        LongName: 'Republic of South Africa',
        ISOCode: 'ZA',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0007',
        AddressFormatName: 'Street;PostCode;Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'ZMB',
        ShortName: 'Zambia',
        LongName: 'Republic of Zambia',
        ISOCode: 'ZM',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0001',
        AddressFormatName: 'Street;City_State_PostCode; Country/Region',
        ExtensionProperties: []
    },
    {
        CountryRegionId: 'ZWE',
        ShortName: 'Zimbabwe',
        LongName: 'Republic of Zimbabwe',
        ISOCode: 'ZW',
        TimeZone: 0,
        LanguageId: 'en-us',
        AddressFormatLines: [
            {
                AddressComponentNameValue: 6,
                LineNumber: 1,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 2,
                LineNumber: 2,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 4,
                LineNumber: 3,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 1,
                Separator: ' ',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 1,
                LineNumber: 4,
                IsDataEntryOnly: false,
                NewLine: true,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            },
            {
                AddressComponentNameValue: 5,
                LineNumber: 5,
                IsDataEntryOnly: false,
                NewLine: false,
                Expand: false,
                Inactive: false,
                Special: false,
                NumberOfSpaces: 0,
                Separator: '',
                ExtensionProperties: []
            }
        ],
        AddressFormatId: '0001',
        AddressFormatName: 'Street;City_State_PostCode; Country/Region',
        ExtensionProperties: []
    }
];

export default mockCountryRegions;
